import type {
  CreateMembershipPlanRequest,
  ListMembershipPlansResponse,
  MembershipPlanResponse,
  UpdateMembershipPlanRequest,
} from '@jq4race/shared';

import { request } from './client.js';

// frequent-customer-memberships · Slice S1b — org-level Membership Plan
// configuration (Capability 1). Unlike tariffs/zones, plans are NOT
// location-scoped — routes hang off /admin/membership-plans directly.

export async function listMembershipPlans(params?: {
  active?: boolean;
}): Promise<ListMembershipPlansResponse> {
  const qs = params?.active !== undefined ? `?active=${params.active}` : '';
  return request<ListMembershipPlansResponse>(`/admin/membership-plans${qs}`, { method: 'GET' });
}

export async function createMembershipPlan(
  input: CreateMembershipPlanRequest,
): Promise<MembershipPlanResponse> {
  return request<MembershipPlanResponse>('/admin/membership-plans', {
    method: 'POST',
    body: input,
  });
}

export async function updateMembershipPlan(
  planId: string,
  input: UpdateMembershipPlanRequest,
): Promise<MembershipPlanResponse> {
  return request<MembershipPlanResponse>(`/admin/membership-plans/${encodeURIComponent(planId)}`, {
    method: 'PATCH',
    body: input,
  });
}
